import PropTypes from "prop-types";
import React from 'react';
import './table_pagination.scss';

const Pagination = ({ currentPage, lastPage, fetchData, type = '', customClasses }) => {

  currentPage = parseInt(currentPage, 10);
  lastPage = parseInt(lastPage, 10);

  const renderPageLink = (page) =>
    <a className='table-page' onClick={() => { fetchData(page, type); }}>{page}</a>;

  const renderPageSeparator = () => <div className='table-page'> ... </div>;

  return (
    <div className={`table-pagination ${customClasses && customClasses.join(' ')}`}>
      {currentPage > 4 ? renderPageLink(1) : null}
      {currentPage > 4 ? renderPageSeparator() : null}
      {currentPage > 3 ? renderPageLink(currentPage - 3) : null}
      {currentPage > 2 ? renderPageLink(currentPage - 2) : null}
      {currentPage > 1 ? renderPageLink(currentPage - 1) : null}
      <div className='table-page current-page'>{currentPage}</div>
      {currentPage < lastPage ? renderPageLink(currentPage + 1) : null}
      {currentPage < lastPage - 1 ? renderPageLink(currentPage + 2) : null}
      {currentPage < lastPage - 2 ? renderPageLink(currentPage + 3) : null}
      {currentPage < lastPage - 3 ? renderPageSeparator() : null}
      {currentPage < lastPage - 3 ? renderPageLink(lastPage) : null}
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  lastPage: PropTypes.number.isRequired,
  fetchData: PropTypes.func.isRequired,
  customClasses: PropTypes.array
};

export default Pagination;
